import { render, staticRenderFns } from "./Revisar.vue?vue&type=template&id=687e7a6a&"
import script from "./Revisar.vue?vue&type=script&lang=js&"
export * from "./Revisar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports